module.exports = __webpack_public_path__ + "static/media/TitlePage_2.809af5e9.gif";